<template>
  <!-- Hero Slider Section -->
  <section class="hero-slider" id="hero">
    <div class="slider-container">
      <div 
        class="slide" 
        v-for="(slide, index) in heroSlides" 
        :key="slide.id"
        :class="{ 'active': currentSlide === index }"
        :style="{ backgroundImage: `url(${slide.backgroundImage})` }"
      >
        <div class="slide-overlay"></div>
        <div class="slide-content">
          <div class="slide-text">
            <h1 class="slide-title">{{ slide.title }}</h1>
            <p class="slide-description">{{ slide.description }}</p>
            <div class="slide-actions">
              <button class="cta-btn secondary" @click="handleSlideAction('projects')">
                {{ locale === 'tr' ? 'Projelerimiz' : 'Our Projects' }}
              </button>
              <button class="cta-btn secondary" @click="handleSlideAction('machinery')">
                {{ locale === 'tr' ? 'Makine Parkımız' : 'Our Machinery' }}
              </button>
              <button class="cta-btn secondary" @click="handleSlideAction('services')">
                {{ locale === 'tr' ? 'Hizmetlerimiz' : 'Our Services' }}
              </button>
              <button class="cta-btn secondary" @click="handleSlideAction('contact')">
                {{ locale === 'tr' ? 'İletişim Bilgileri' : 'Contact Info' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Slider Navigation -->
    <!-- 
    <div class="slider-nav">
      <button 
        class="nav-dot" 
        v-for="(slide, index) in heroSlides" 
        :key="index"
        :class="{ 'active': currentSlide === index }"
        @click="goToSlide(index)"
      ></button>
    </div>
    -->
    
    <!-- Slider Arrows -->
    <button class="slider-arrow prev" @click="prevSlide">
      <span>‹</span>
    </button>
    <button class="slider-arrow next" @click="nextSlide">
      <span>›</span>
    </button>
    
    <!-- Slide Counter -->
    <div class="slide-counter">
      {{ currentSlide + 1 }} / {{ heroSlides.length }}
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useHeroSlides } from '@/composables/useHeroSlides'

// Props
const props = defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Computed locale
const locale = computed(() => props.locale)

// Composable kullanımı
const { 
  heroSlides, 
  currentSlide, 
  goToSlide, 
  nextSlide, 
  prevSlide, 
  handleSlideAction,
  startSlider,
  stopSlider
} = useHeroSlides(locale)

// Lifecycle
onUnmounted(() => {
  stopSlider()
})
</script>